import { useCompany } from "@/context/CompanyContext";
import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuSeparator, DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";
import { ChevronsUpDown, Check, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CompanySwitcher({ compact = false }) {
  const { companies, currentCompany, switchCompany } = useCompany();
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const testScope = compact ? "-mobile" : "";

  if (!currentCompany) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={`flex items-center gap-2 min-w-0 max-w-full w-full ${compact ? "px-2 py-1.5" : "px-3 py-2"} rounded-md border border-zinc-200 bg-white hover:bg-zinc-50 text-left`}
          title={currentCompany.name}
          aria-label={`Aktif şirket: ${currentCompany.name}`}
          data-testid={`company-switcher${testScope}`}
        >
          <div
            className="w-7 h-7 rounded flex items-center justify-center text-white text-[11px] font-bold shrink-0"
            style={{ background: currentCompany.color || "#09090B" }}
          >
            {(currentCompany.short_name || currentCompany.name).slice(0, 2).toLocaleUpperCase("tr-TR")}
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-[10px] text-zinc-500 uppercase tracking-widest leading-none">Aktif Şirket</div>
            <div className="text-sm font-semibold text-zinc-900 truncate leading-tight" data-testid={`company-switcher-name${testScope}`}>{currentCompany.name}</div>
          </div>
          <ChevronsUpDown size={14} className="text-zinc-400 shrink-0" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64" data-testid={`company-switcher-menu${testScope}`}>
        <DropdownMenuLabel className="nf-label">Şirketler</DropdownMenuLabel>
        {companies.map((c) => (
          <DropdownMenuItem
            key={c.id}
            onClick={() => switchCompany(c.id)}
            className="gap-2 cursor-pointer"
            data-testid={`switch-to${testScope}-${c.id}`}
          >
            <div className="w-6 h-6 rounded flex items-center justify-center text-white text-[10px] font-bold"
                 style={{ background: c.color || "#09090B" }}>
              {(c.short_name || c.name).slice(0, 2).toLocaleUpperCase("tr-TR")}
            </div>
            <span className="flex-1 truncate">{c.name}</span>
            {c.id === currentCompany.id && <Check size={14} className="text-emerald-600" />}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        {isAdmin && (
          <DropdownMenuItem
            onClick={() => navigate("/sirket-sec")}
            className="cursor-pointer gap-2"
            data-testid={`manage-companies${testScope}`}
          >
            <Plus size={14} /> Şirket Ekle / Yönet
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
